import { usePhotos } from "@/lib/usePhotos";

export default function AboutPage() {
    const photos = usePhotos();
    const aboutImg =
        photos.about ||
        "https://images.pexels.com/photos/28215117/pexels-photo-28215117.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1600";
    return (
        <div data-testid="about-page" className="pt-32 lg:pt-40 pb-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <span className="overline">About Coral Bay Catering</span>
                        <h1 className="font-serif font-light text-5xl md:text-6xl lg:text-7xl text-forest-700 mt-5 leading-[1.05]">
                            Hi, I'm <em className="italic">the chef behind Coral Bay Catering.</em>
                        </h1>
                        <div className="space-y-6 text-forest-700/75 leading-relaxed mt-8 max-w-2xl">
                            <p>
                                For over twenty-three years I've had the joy of cooking
                                for the St. John community — feeding friends, families,
                                wedding parties, and a whole lot of dreamy vacations.
                            </p>
                            <p>
                                Coral Bay Catering started with humble beginnings: the
                                dream to serve delectable cuisine created with heart
                                using locally sourced fresh ingredients. We don't just
                                cater food — we cultivate experiences. Small details
                                add up to make big lasting impressions.
                            </p>
                            <p>
                                Although we offer a wide variety of menu items, every
                                menu is subject to last-minute changes due to
                                availability of product. This is a normal occurrence
                                on a tiny island with extremely limited resources —
                                and it's where our creativity shines brightest.
                            </p>
                            <p>
                                Whether you're planning an intimate villa dinner or a
                                larger celebration, our team can guide you through
                                flowers, decor, music, entertainment, transportation,
                                valet, tents, rentals and more. Reach out early — our
                                calendar fills up quickly.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="aspect-[4/5] overflow-hidden rounded-sm bg-sand-200">
                            <img
                                src={aboutImg}
                                alt="In the kitchen"
                                className="w-full h-full object-cover"
                                loading="eager"
                            />
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-24 pt-12 border-t border-palm-400/30">
                    {[
                        ["23+", "Years on St. John"],
                        ["100%", "Locally sourced when possible"],
                        ["6", "Guest minimum per booking"],
                        ["50%", "Deposit to confirm"],
                    ].map(([n, l]) => (
                        <div key={l} data-testid={`stat-${l.toLowerCase().replace(/\s+/g, "-")}`}>
                            <div className="font-serif text-5xl text-forest-700">{n}</div>
                            <div className="text-sm text-forest-700/60 mt-2">{l}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
